import type { DeIdentificationRule } from '../../entities/ai-assist-config';

export interface RestoreDeidentificationResult {
  text: string;
  issues: string[];
}

export function restoreDeidentificationRules(input: string, rules: DeIdentificationRule[]): RestoreDeidentificationResult {
  const issues: string[] = [];
  const activeRules = rules.filter((rule) => rule.enabled && rule.conflictStatus === 'valid');
  const replacementCollisionCount = new Map<string, number>();

  for (const rule of rules.filter((rule) => rule.enabled)) {
    replacementCollisionCount.set(rule.replacementValue, (replacementCollisionCount.get(rule.replacementValue) ?? 0) + 1);
  }

  let text = input;
  for (const rule of activeRules.slice().sort((left, right) => right.replacementValue.length - left.replacementValue.length || left.ruleId.localeCompare(right.ruleId))) {
    if ((replacementCollisionCount.get(rule.replacementValue) ?? 0) > 1) {
      issues.push(`Replacement "${rule.replacementValue}" cannot be restored safely.`);
      continue;
    }
    text = text.split(rule.replacementValue).join(rule.originalValue);
  }

  return {
    text,
    issues: [...new Set(issues)],
  };
}
